module.exports = __webpack_public_path__ + "JAGUAR-logo.png";